import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from './api';
export function useData<T = any>(path: string | null, interval = 0, load?: (signal:AbortSignal)=>Promise<T>) {
  const [data, setData] = useState<T | null>(null), [error, setError] = useState(''), [loading, setLoading] = useState(true);
  const [updatedAt, setUpdatedAt] = useState<number | null>(null);
  const controller = useRef<AbortController | null>(null);
  const refresh = useCallback(async () => {
    // A slow response must finish; polling must not cancel it on every tick.
    if (controller.current && !controller.current.signal.aborted) return;
    const request = new AbortController(); controller.current = request;
    try {
      if (!path) { setData(null); setUpdatedAt(null); return; }
      const result = load ? await load(request.signal) : await api<T>(path, {signal: request.signal});
      if (!request.signal.aborted) { setData(result); setUpdatedAt(Date.now()); setError(''); }
    } catch (e) {
      if (!request.signal.aborted) setError(e instanceof Error ? e.message : 'Unable to load this view.');
    } finally {
      if (!request.signal.aborted) setLoading(false);
      if (controller.current === request) controller.current = null;
    }
  }, [path,load]);
  useEffect(()=>{const update=()=>{void refresh();};window.addEventListener('overture-demo-update',update);return()=>window.removeEventListener('overture-demo-update',update);},[refresh]);
  useEffect(() => { setData(null); setUpdatedAt(null); setError(''); setLoading(true); void refresh(); const id = interval?window.setInterval(refresh, interval):undefined; return () => {if(id)window.clearInterval(id);controller.current?.abort();}; }, [refresh, interval]);
  return { data, error, loading, refresh, updatedAt };
}
